export const CRON_START = "[CRON] Cron Job Start";
export const CRON_FAIL = "[CRON] Crob Job Fail";
export const GET_CRON_JOBS = "[CRON] Get Cron Jobs";
export const GET_CRON_JOBS_SUCCESS = "[CRON] Get Cron Jobs Success";
export const CREATE_CRON_JOB = "[CRON] Create Cron Job";
export const CREATE_CRON_JOB_SUCCESS = "[CRON] Create Cron Job Success";
